export const dispatchAddToBasket = (productIds, bundleType) => {
  const dispatch = window.appState ? window.appState.dispatch : () => {};

  dispatch({
    type: 'BUNDLE_ADD_TO_BASKET',
    payload: {
      bundleProductIds: productIds,
      bundleType: bundleType,
      trackFunctionArgs: 'bundleAddToBasket'
    }
  });
};

export const dispatchAddProductToBundle = (productId) => {
  const dispatch = window.appState ? window.appState.dispatch : () => {};

  dispatch({
    type: 'BUNDLE_ADD_PRODUCT',
    payload: {
      productId,
      trackFunctionArgs: 'itemAddedToBundle'
    }
  });
};

export const dispatchRemoveProductFromBundle = (productId) => {
  const dispatch = window.appState ? window.appState.dispatch : () => {};

  dispatch({
    type: 'BUNDLE_REMOVE_PRODUCT',
    payload: {
      productId,
      trackFunctionArgs: 'itemRemovedFromBundle'
    }
  });
};

export const dispatchSetProductBundlesListForDynamicBundle = (bundles) => {
  const dispatch = window.appState ? window.appState.dispatch : () => {};

  dispatch({
    type: 'SET_PRODUCT_BUNDLES_LIST',
    payload: { bundles }
  });
};

export function dispatchSetProductBundlesListForStaticBundles(bundles) {
  const dispatch = window.appState ? window.appState.dispatch : () => {};

  dispatch({
    type: 'SET_PRODUCT_BUNDLES_LIST',
    payload: {
      bundles: [
        ...bundles.map((bundle) => ({
          bundleType: bundle.recommendationType,
          bundleExecution: bundle.bundleType
        }))
      ]
    }
  });
}
